import { VZButton } from 'components/Button/button.styles';
import { Input } from 'components/Form';
import { Message } from 'models';
import React, { useState } from 'react';
import { FormRenderProps } from 'react-final-form';
import { ContentUtil } from 'utils';

import IOutageSubscribeFormProps from './Interface/IOutageSubscribeFormProps';
import { content } from './outage-overview.content';
import * as Styles from './outage-overview.styles';

const contentUtil = new ContentUtil({ content, componentName: 'OutageOverview' });

const OutageSubscribeForm = (props: IOutageSubscribeFormProps) => {
  const [maxNumbers, setMaxNumbers] = useState<boolean>(false);
  const [numberInputs, setNumberInputs] = useState([{ label: contentUtil.translateToString('phoneNumberLabel') }]);

  const submit = async (values: Record<string, string[]>): Promise<void> => {
    props.onSubmit(props.outage.ticketId, values.telephoneNumbers);
  };

  const addNumberField = () => {
    const numberInputsCopy = [...numberInputs];
    numberInputsCopy.push({ label: contentUtil.translateToString('phoneNumberLabel') });
    setNumberInputs(numberInputsCopy);
    setMaxNumbers(numberInputsCopy.length >= 10);
  };

  const renderNumberInputs = (validators: { [key: string]: (value: string | undefined) => undefined | Message }) => {
    return numberInputs.map((input, index) => (
      <Input
        key={`number-input-${index}`}
        label={input.label}
        name={`telephoneNumbers[${index}]`}
        validate={[validators.mobile]}
        type="tel"
      />
    ));
  };

  const isSubscribeButtonDisabled = (formApi: FormRenderProps<unknown, Partial<unknown>>): boolean => {
    const values = formApi.values as Record<string, string[]>;
    const { telephoneNumbers } = values;

    return (
      !Array.isArray(telephoneNumbers) ||
      (Array.isArray(telephoneNumbers) && telephoneNumbers.filter(Boolean).length === 0)
    );
  };

  return (
    <Styles.Form
      onSubmit={submit}
      data-testid="outage-subscribe-form"
      hideSubmitButton
      hideCancelButton
      render={(formApi, validators) => (
        <>
          {renderNumberInputs(
            validators as unknown as { [key: string]: (value: string | undefined) => undefined | Message }
          )}

          <Styles.ButtonsContainer className="form-button">
            <VZButton testid="form-cancel-button" onClick={addNumberField} variant="outlined" disabled={maxNumbers}>
              {contentUtil.translateToString('addNumber')}
            </VZButton>

            <VZButton type="submit" testid="form-submit-button" disabled={isSubscribeButtonDisabled(formApi)}>
              {contentUtil.translateToString('subscribe')}
            </VZButton>
          </Styles.ButtonsContainer>
        </>
      )}
    />
  );
};

export default OutageSubscribeForm;
